import {NewTableDef, TableColumnDef} from 'app/shared/tables/table-column-def';

export class NotificationModel {
    Id: number;
    Message: string;
    Status: 'READ' | 'UNREAD';
    Type: string;
    CreatedAt: string;
    Area: string;
    Title: string;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'NotificationModel',
            columns: [
                { columnDef: 'Id' },
                {
                    field: 'Title',
                    columnDef: 'Title',
                    header: 'Nazwa',
                    isGeneralSearchColumn: true,
                    width: 30,
                    tooltipEnabled: true,
                },
                {
                    field: 'Message',
                    columnDef: 'Message',
                    header: 'SZCZEGÓŁY',
                    width: 40,
                    tooltipEnabled: true,
                },
                {
                    field: 'Area',
                    columnDef: 'Area',
                    header: 'OBSZAR',
                    width: 15,
                },
                {
                    field: 'CreatedAt',
                    columnDef: 'CreatedAt',
                    header: 'Dataczas',
                    width: 15,
                    type: 'datetime',
                },
            ]
        };
    }
}

export enum NotificationModelEnum {
    SIMULATION_SCENERIO = 'Scenariusze',
    BASKET = 'Koszyki',
    INVENTORY = 'Import Danych',
    OTHER = 'Inne',
}

export interface NotificationConfigModel {
    NotificationType: string;
    IsEnabled: boolean;
    DisplayName: string;
}
